// style //
import "./NavBar.css";

import React, { useEffect, useState, useRef } from "react";

// Images //
import { icons, images } from "../../../assets/index";

// Components //
import Pagination from "rc-pagination";
import { TableRowLoader } from "../../components/index";

// Hooks //
import { useSelector } from "react-redux";
import { dateFormatFullMonth } from "../../../constents";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// Actions //
import {
  receivedError,
  requestSent,
  responseRecived,
} from "../../../redux/actions/utilsActions";

const NavBar = () => {
  // Hooks //
  const { user, userToken } = useSelector((state) => state.user)
  const { loading } = useSelector((state) => state.utils);

  const { data: contractorStats } = useSelector((state) => state.contractorStats);
  const [totalCount, setTotalCount] = useState(50);
  const [limitPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const [counts, setCounts] = useState(0)
  const navigate = useNavigate()


  const dropdownRef = useRef();

  return (
    <div className="nav-bar_cont">
      <div className="text_cont">
        <img src={icons.subContractor} alt="" />
        {contractorStats?.soleTraderMissingIf ? (
          <p>
            You have {contractorStats.soleTraderMissingIf} Sub-contractors who need to
            complete their setup
          </p>
        ) : (
          <p>
            You Do Not have Any Sub-contractors who need to complete their setup
          </p>
        )}

      </div>
      <div className="profile_cont">
        <div className="profile-img">
          <img src={user.contractorData?.Company?.logo ? `${user.public_path}${user.contractorData.Company.logo}` : images.PersonPlaceHolder} alt="" />
        </div>
        <div className="profile-name_cont" onClick={() => navigate('/settings')}>
          <p>{user.contractorData?.Company?.name}</p>
          {/* <p>Digger Ticket</p> */}
        </div>
      </div>
    </div>
  );
};

export default NavBar;